import WarehouseDeleteModal from './WarehouseDeleteModal';
export default WarehouseDeleteModal;
